<script setup lang="ts">
  import type { Social } from '@/models/social';
  import { useLegalDocumentStore } from '@/stores/legal-document-store';

  defineProps({
    socials: {
      type: Array as PropType<Social[]>,
      required: true
    }
  });

  const localePath = useLocalePath();

  const { getDocumentSlugForAlias } = useLegalDocumentStore();
</script>

<template>
  <footer class="app-footer">
    <div class="app-footer__logo">
      <img
        src="~/assets/images/logo-footer.svg"
        alt="logo" />
      <span>{{ $t('footer.copyright') }}</span>
    </div>
    <div class="app-footer__menu">
      <NuxtLink :to="localePath({ name: 'cookie' })">{{ $t('footer.cookieSettings') }}</NuxtLink>
      <NuxtLink :to="localePath({ name: 'documents-dslug', params: { dslug: getDocumentSlugForAlias('legalDocument') } })">
        {{ $t('footer.privacyPolicy') }}
      </NuxtLink>
    </div>
    <div class="app-footer__social">
      <a
        v-for="(social, index) in socials"
        :key="index"
        :href="social.url"
        target="_blank">
        <img
          :src="social.logo?.src ?? ''"
          :alt="social.title" />
      </a>
    </div>
  </footer>
</template>
